require("./dataset/DatasetModel");

var echarts = require("../echarts");

echarts.extendComponentView({
  type: 'dataset'
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataset.js
// module id = 637
// module chunks = 0